<p>Kreator bloków paragonu</p>
<h3>Rekbot ID - {{ rekbotID }}</h3>
<div class="row">
    <div class="col-6">
        <div class="row" class="">
            <div class="col">
                <mat-form-field>
                    <mat-label>Typ bloku</mat-label>
                    <mat-select [(ngModel)]="selectedBlockType">
                        @for (item of blockTypes; track item) {
                        <mat-option [value]="item.value">{{item.viewValue}}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col">
                <mat-form-field>
                    <mat-label>Nazwa:</mat-label>
                    <input matInput type="text" [(ngModel)]="newBlockName">
                </mat-form-field>
            </div>
            <div class="col">
                <button mat-flat-button class="btn btn-primary btn-action" color="accent" (click)="addBlock()"
                    [disabled]="newBlockName.length == 0 || selectedBlockType.length == 0">Dodaj blok</button>
            </div>
        </div>
    </div>
    <div class="col-6" style="border-left: 1px solid black;">
        <div>
            <p>Utworzone bloki</p>

            <div *ngFor="let bb of blockService.getList()" (click)="selectBlock(bb)"
                style="margin:5px;padding:10px;border: 1px solid gray;">
                {{ bb.name }} ({{ bb.type }})
            </div>


        </div>
    </div>
</div>
<hr>
<div class="row" *ngIf="currentBlock !== undefined && currentBlock.type === 'text'">
    <div class="col">

        <h4>Edycja bloku Tekstowego</h4>
        <mat-form-field>
            <mat-label>Nazwa:</mat-label>
            <input matInput type="text" [(ngModel)]="currentBlock.name">
        </mat-form-field>
        <hr>
        <div class="row" style="margin-top:15px;">
            <div class="col-8">
                <div class="row">
                    <div class="col">
                        <mat-toolbar>
                            <mat-button-toggle-group [(ngModel)]="toggleGr" aria-label="Font Style" multiple
                                (change)="groupChange()">
                                <mat-button-toggle name="isBold" ngDefaultControl value="bold"
                                    (change)="boldChanged()">Bold</mat-button-toggle>
                                <mat-button-toggle name="isItalic" ngDefaultControl value="italic"
                                    (change)="italicChanged()">Italic</mat-button-toggle>
                                <mat-button-toggle name="isUnderline" ngDefaultControl
                                    value="underline"
                                    (change)="uderlineChanged()">Underline</mat-button-toggle>
                            </mat-button-toggle-group>
                        </mat-toolbar>
                    </div>
                </div>
                <h5>Zmienne systemowe</h5>
                <div class="row">
                    <div class="col">
                        <mat-toolbar>
                            <button mat-stroked-button (click)="insertSerialNumber()">Wstaw numer seryjny</button>
                            <button mat-stroked-button (click)="insertCurrency()">Wstaw kod waluty</button>
                            <button mat-stroked-button (click)="insertStreet()">Wstaw ulicę</button>
                            <button mat-stroked-button (click)="insertCity()">Wstaw miasto</button>
                            <button mat-stroked-button (click)="insertPostCode()">Wstaw kod pocztowy</button>
                            <button mat-stroked-button (click)="insertCountry()">Wstaw państwo</button>
                        </mat-toolbar>
                    </div>
                </div>
                <h5>Zmienne daty i czasu</h5>
                <div class="row">
                    <div class="col">
                        <mat-toolbar>
                            <button mat-stroked-button (click)="insertCurrretDate()">Wstaw bieżącą datę</button>
                            <button mat-stroked-button (click)="insertFillSpace()">Wstaw wypełnienie</button>
                            <button mat-stroked-button (click)="insertSeparatingLine()">Wstaw linię rozdzielającą</button>
                        </mat-toolbar>
                    </div>
                </div>
                <h5>Zmienne paragonu</h5>
                <div class="row">
                    <div class="col">
                        <mat-toolbar>
                            <button mat-stroked-button (click)="insertVoucherValue()">Wstaw wartość paragonu</button>
                            <button mat-stroked-button (click)="insertPackagesCount()">Wstaw liczbę opakowań</button>
                            <button mat-stroked-button (click)="insertBottlesCount()">Wstaw liczbę butelek</button><br>
                            <button mat-stroked-button (click)="insertCansCount()">Wstaw liczbę puszek</button>
                        </mat-toolbar>
                        <mat-toolbar>
                            <button mat-stroked-button (click)="insertVoucherId()">Wstaw ID paragonu</button>
                            <button mat-stroked-button (click)="insertVoucherDateCode()">Wstaw datę paragonu</button>
                            <button mat-stroked-button (click)="insertVoucherExpirationDate()">Wstaw datę ważności</button>
                        </mat-toolbar>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <mat-form-field>
                            <mat-label>Wyrównanie</mat-label>
                            <mat-select [(ngModel)]="textBlockValues.align">
                                @for (item of alignTypes; track item) {
                                <mat-option [value]="item.value">{{item.viewValue}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>Typ fontu</mat-label>
                            <mat-select [(ngModel)]="textBlockValues.fontType">
                                @for (item of fontTypes; track item) {
                                <mat-option [value]="item.value">{{item.viewValue}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label>Rozmiar fontu</mat-label>
                            <mat-select [(ngModel)]="textBlockValues.fontSize">
                                @for (item of fontSizes; track item) {
                                <mat-option [value]="item.value">{{item.viewValue}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>

                    </div>
                </div>
            </div>
            <div class="col-4">
                <mat-form-field style="width:500px;">
                    <mat-label>Pole tekstowe</mat-label>
                    <textarea matInput #textArea cdkAutosizeMinRows="5" cdkAutosizeMaxRows="5" [(ngModel)]="blockText" style="height:300px;"
                        (change)="blockTextChanged()"></textarea>
                </mat-form-field>
            </div>
        </div>
        <hr>

        <button mat-flat-button class="btn btn-primary btn-action" color="accent" (click)="updateTextBlock()"
            [disabled]="currentBlock.name.length == 0">Zapisz blok</button>
    </div>

</div>
<div class="row" *ngIf="currentBlock !== undefined && currentBlock.type === 'image'">
    <div class="col">
        <h4>Edycja bloku obrazu</h4>
        <mat-form-field>
            <mat-label>Nazwa:</mat-label>
            <input matInput type="text" [(ngModel)]="currentBlock.name">
        </mat-form-field>
        <hr>
    
        <div class="col" style="display: flex;gap:10px;">
            <mat-form-field>
                <mat-label>Plik graficzny:</mat-label>
                <mat-select [(ngModel)]="imageBlockValues.imagePath">
                    @for (item of imagePaths; track item) {
                    <mat-option [value]="item.value">{{item.viewValue}}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
            <mat-form-field>
                <mat-label>Wyrównanie:</mat-label>
                <mat-select [(ngModel)]="imageBlockValues.align">
                    @for (item of imageAlign; track item) {
                    <mat-option [value]="item.value">{{item.viewValue}}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
            <mat-form-field>
                <mat-label>Szerokość:</mat-label>
                <input matInput type="text" [(ngModel)]="imageBlockValues.width">
            </mat-form-field>
            <mat-form-field >
                <mat-label>Wysokość:</mat-label>
                <input matInput type="text" [(ngModel)]="imageBlockValues.height">
            </mat-form-field>
        </div>
        <hr>
        <button mat-flat-button class="btn btn-primary btn-action" color="accent" (click)="updateImageBlock()"
            [disabled]="currentBlock.name.length == 0">Zapisz blok</button>

    </div>
</div>
<div class="row" *ngIf="currentBlock !== undefined && currentBlock.type === 'barcode'">
    <div class="col">
        <h4>Edycja bloku kodu kreskowego</h4>
        <mat-form-field>
            <mat-label>Nazwa:</mat-label>
            <input matInput type="text" [(ngModel)]="currentBlock.name">
        </mat-form-field>
        <hr>
        <div class="col" style="display: flex;gap:10px;">
            <mat-form-field>
                <mat-label>Wartość:</mat-label>
                <input matInput type="text" [(ngModel)]="barcodeBlockValues.value">
            </mat-form-field>
            <mat-form-field>
                <mat-label>Typ kodu:</mat-label>
                <mat-select [(ngModel)]="barcodeBlockValues.barcode_type">
                    @for (item of barcodeTypes; track item) {
                    <mat-option [value]="item.value">{{item.viewValue}}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
            <mat-form-field>
                <mat-label>Pozycja kodu:</mat-label>
                <input matInput type="text" [(ngModel)]="barcodeBlockValues.textPosition">
            </mat-form-field>
            <mat-form-field >
                <mat-label>Szerokość:</mat-label>
                <input matInput type="text" [(ngModel)]="barcodeBlockValues.width">
            </mat-form-field>
            <mat-form-field >
                <mat-label>Wysokość:</mat-label>
                <input matInput type="text" [(ngModel)]="barcodeBlockValues.height">
            </mat-form-field>
            <mat-form-field >
                <mat-label>Justowanie:</mat-label>
                <mat-select [(ngModel)]="barcodeBlockValues.justification">
                    @for (item of justifications; track item) {
                    <mat-option [value]="item.value">{{item.viewValue}}</mat-option>
                    }
                </mat-select>

            </mat-form-field>
        </div>
        <hr>

        <button mat-flat-button class="btn btn-primary btn-action" color="accent" (click)="updateBarcodeBlock()"
            [disabled]="currentBlock.name.length == 0">Zapisz blok</button>

    </div>
</div>
<hr>
<div class="component">
</div>